import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, HostListener, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { AbstractControl, FormGroup, FormArray, FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { GlobalService } from '../../_services/global.service';
import { JsonService, LoggerService } from '../../_services';
import { ValidacaoPrescriptionPendenteItem } from '../../_models/prescription-validacao-pendentes-item.model';
import { ChildActivationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-doctor-form-pending',
  templateUrl: './doctor-form-pending.component.html',
  styleUrls: ['./doctor-form-pending.component.scss', '../../detalhe/detalhe.component.scss']
})
export class DoctorFormPendingComponent implements OnInit, OnChanges, AfterViewInit {
  //@Input() medicoForm!: FormGroup;
  @Input() medicoForm!: FormGroup;
  @Input() prescriptionItem?: ValidacaoPrescriptionPendenteItem;
  @Input() isSmartCase!: boolean;
  @Input() isVisibleEnderecoMedico!: boolean;
  @Input() codigoPaisMaestro: string = '';
  @Input() codigoRegiaoMaestro: string = '';
  @Input() mostrarPendencias: boolean = false;

  @Output() validarEntrada = new EventEmitter<void>();
  @Output() isValidatedChange = new EventEmitter<boolean>();

  @Output() focusProduct = new EventEmitter<void>();

  @ViewChild('retornoMedSelect') retornoMedSelect?: ElementRef;
  @ViewChild('retornoMedInput') retornoMedInput?: ElementRef;

  public crmFiltrado: any[] = [];
  public nomeMedicoFiltrado: any[] = [];
  public especialidadeFiltrado: string[] = [];

  isModalMedicoOpen: boolean = false;
  pesquisaMedico: string = '';
  medicoSelecionadoNome: string = '';
  medicoSelecionadoCombobox: string = '';
  listaMedicosFiltrada: any[] = [];
  listaMedicosCompleta: any[] = [];
  private focusComboOnLoad: boolean = false;
  private isBuscandoMedicos: boolean = false;
  private ultimoTermoBuscaMedicoApi: string = '';
  private termoBuscaMedicoPendente: string = '';
  matriculaSelecionada: any;
  isMedicoVerificadoChecked: boolean = false;
  isMedicoInsercaoManualAtiva: boolean = false;

  constructor(
    public global: GlobalService, 
    private jsonService: JsonService, 
    private logger: LoggerService,
    private translate: TranslateService) {}

  onMedicoValidadoChange(event: any): void {
    this.isMedicoVerificadoChecked = event.target.checked;
    if (event.target.checked) {
      this.setInteraction('marcado checkbox não encontrado.');
    }
    this.atualizarValidacao();
  }

  setInteraction(interaction: string): void {
    if (this.medicoForm && this.medicoForm.get('interaccion_del_usuario')?.value !== interaction) {
      this.medicoForm.get('interaccion_del_usuario')?.setValue(interaction, { emitEvent: false });
    }
  }

  onRetornoMedInput(): void {
    this.setInteraction('Item informado pelo usuário');
    this.atualizarValidacao();
  }

  ativarEntradaManualMedico(): void {
    this.isMedicoInsercaoManualAtiva = true;
    setTimeout(() => this.retornoMedInput?.nativeElement?.focus(), 0);
  }

  public campoValido: boolean = false;

  atualizarValidacao(): void {
    const retornoMed = this.medicoForm?.get('retorno_med')?.value;
    const isInformado = typeof retornoMed === 'string' ? retornoMed.trim() !== '' : !!retornoMed;
    this.campoValido = this.isValidMed() || isInformado || this.isMedicoVerificadoChecked;
    this.isValidatedChange.emit(this.campoValido);
    this.tratarPermissaoEdicao();
  }

  private tratarPermissaoEdicao(): void {
    if (!this.medicoForm) return;

    // Edição manual sempre liberada em todos os campos do bloco, independente do
    // status (Válido/Ambíguo/Não encontrado) — decisão deliberada.
    const camposControlados = [
      'nome', 'matricula', 'email', 'cdgCiudad',
      'rua', 'localidade', 'telefone', 'especialidade',
      'retorno_matricula', 'retorno_matricula1', 'retorno_matricula2',
      'retorno_esp1', 'retorno_esp2', 'retorno_esp3',
      'retorno_direccion', 'retorno_localid'
    ];

    camposControlados.forEach(c => this.medicoForm.get(c)?.enable({ emitEvent: false }));
  }

  ngAfterViewInit(): void {
    this.aplicarFocoStatus();
  }

  public aplicarFocoStatus(): void {
    setTimeout(() => {
      if (!this.isValidMed()) {
        if (this.retornoMedSelect?.nativeElement) {
          this.retornoMedSelect.nativeElement.focus();
        } else if (this.retornoMedInput?.nativeElement) {
          this.retornoMedInput.nativeElement.focus();
        }
      } else {
        this.focusProduct.emit();
      }
    }, 500);
  }

  ngOnInit(): void {
    // Nome do médico
    this.medicoForm.get('nome')?.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterNome(value))
      )
      .subscribe(filtrado => this.nomeMedicoFiltrado = filtrado);

    // Forçar atualização se prescriptionItem já chega definido
    if (this.prescriptionItem) {
      const filter = this.parseConteudoMedFiltro(this.prescriptionItem.conteudoMed);
      this.medicoForm.patchValue({
        validMed: this.prescriptionItem.validMed ?? false,
        ConteudoMedFiltro: filter
      }, { emitEvent: false });
      this.autoSelectFirstMatch(filter);
    }

    setTimeout(() => this.atualizarValidacao(), 0);

    // CRM
    // this.medicoForm.get('matricula')?.valueChanges
    //   .pipe(
    //     startWith(''),
    //     map(value => this._filterCrm(value))
    //   )
    //   .subscribe(filtrado => this.crmFiltrado = filtrado);

    // // Especialidade (cada input do array)
    // this.especialidadeArray.controls.forEach((ctrl, index) => {
    //   ctrl.valueChanges
    //     .pipe(
    //       startWith(''),
    //       map(value => this._filterEspecialidade(value))
    //     )
    //     .subscribe(filtrado => this.especialidadeFiltrado = filtrado);
    // });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['prescriptionItem']) {
      if (!changes['prescriptionItem'].firstChange) {
        this.isMedicoVerificadoChecked = false;
      this.isMedicoInsercaoManualAtiva = false;
        const filter = this.parseConteudoMedFiltro(this.prescriptionItem?.conteudoMed);
        this.medicoForm.patchValue({
          validMed: this.prescriptionItem?.validMed ?? false,
          ConteudoMedFiltro: filter
        }, { emitEvent: false });
        this.autoSelectFirstMatch(filter);
        
        // Aplica o foco de status ao mudar para a próxima receita ou voltar para a anterior
        this.aplicarFocoStatus();
      }
      setTimeout(() => this.atualizarValidacao(), 0);
    }
    if (changes['medicoForm'] && !changes['medicoForm'].firstChange) {
      this.isMedicoVerificadoChecked = false;
      this.isMedicoInsercaoManualAtiva = false;
      setTimeout(() => this.atualizarValidacao(), 0);
    }
  }

  private autoSelectFirstMatch(filter: any[]): void {
    if (filter.length > 0 && !this.medicoForm.get('retorno_med')?.value) {
      this.updateReturnFields(filter[0]);
    }
  }

  public onMedicoRetornoChange(event: any): void {
    const selectedName = event.target.value;
    const filter = this.medicoForm.get('ConteudoMedFiltro')?.value || [];
    const matched = filter.find((m: any) => m.NOMBRE_MEDICO === selectedName);
    if (matched) {
      this.updateReturnFields(matched);
    }
    this.setInteraction('Item selecionado da ambiguidade');
    this.atualizarValidacao();
  }

  private updateReturnFields(matched: any): void {
    this.medicoForm.patchValue({
      retorno_med: matched.NOMBRE_MEDICO || '',
      retorno_matricula: matched.MATRICULA1 || '',
      retorno_matricula1: matched.MATRICULA2 || '',
      retorno_matricula2: matched.MATRICULA3 || '',
      retorno_esp1: matched.ESPECIALIDAD || '',
      retorno_esp2: matched.ESPECIALIDAD2 || '',
      retorno_esp3: matched.ESPECIALIDAD3 || '',
      retorno_direccion: matched.DIRECCION || '',
      retorno_localid: matched.LOCALIDAD || '',
      retorno_nro_medico: matched.NRO_MEDICO || ''
    }, { emitEvent: false });
  }

  private parseConteudoMedFiltro(value: any): any[] {
    let parsed: any[] = [];
    if (Array.isArray(value)) parsed = value;
    else if (typeof value === 'string') {
      try { parsed = JSON.parse(value); } catch { parsed = []; }
    }
    
    return parsed.map((item: any) => {
      const result = { ...item };
      if (typeof result.NOMBRE_MEDICO === 'string') result.NOMBRE_MEDICO = result.NOMBRE_MEDICO.replace(/'/g, '');
      if (typeof result.MATRICULA1 === 'string') result.MATRICULA1 = result.MATRICULA1.replace(/'/g, '');
      if (typeof result.ESPECIALIDAD === 'string') result.ESPECIALIDAD = result.ESPECIALIDAD.replace(/'/g, '');
      return result;
    });
  }

  // ---------------- FILTROS ----------------
  private _filterNome(value: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return this.global.listaNomeMedico.filter(option =>
      option.nome.toLowerCase().includes(filterValue) ||
      option.matricula.toLowerCase().includes(filterValue)
    );
  }

  // private _filterCrm(value: string): any[] {
  //   const filterValue = value?.toLowerCase() || '';
  //   return this.global.listaCRM.filter(option =>
  //     option.matricula.toLowerCase().includes(filterValue)
  //   );
  // }

  // private _filterEspecialidade(value: string): string[] {
  //   const filterValue = value?.toLowerCase() || '';
  //   return this.global.listaEspecialidade.filter(option =>
  //     option.toLowerCase().includes(filterValue)
  //   );
  // }

  // ---------------- GETTERS ----------------
  get telefoneArray(): FormArray {
    return this.medicoForm.get('telefone') as FormArray;
  }

  get especialidadeArray(): FormArray {
    return this.medicoForm.get('especialidade') as FormArray;
  }

  // ---------------- ADICIONAR / REMOVER ----------------
  addTelefone() {
    if (this.telefoneArray.disabled) return;
    if (this.telefoneArray.length < 2) {
      this.telefoneArray.push(new FormControl(''));
    }
  }

  removeTelefone(index: number) {
    if (this.telefoneArray.disabled) return;
    if (this.telefoneArray.length > 0) {
      this.telefoneArray.removeAt(index);
    }
  }

  addEspecialidade() {
    if (this.especialidadeArray.disabled) return;
    this.especialidadeArray.push(new FormControl(''));
  }

  addEspecialidadeIndex(index: number) {
    if (this.especialidadeArray.disabled) return;
    this.especialidadeArray.insert(index + 1, new FormControl(''));
  }

  removeEspecialidade(index: number) {
    if (this.especialidadeArray.disabled) return;
    if (this.especialidadeArray.length > 1) {
      this.especialidadeArray.removeAt(index);
    }
  }

  // ---------------- SELEÇÃO ----------------
  // onMedicoSelecionado(medicoSelecionado: any) {
  //   this.medicoForm.patchValue({
  //     nome: medicoSelecionado.nome,
  //     matricula: medicoSelecionado.matricula,
  //     email: medicoSelecionado.email,
  //     rua: medicoSelecionado.rua,
  //     localidade: medicoSelecionado.localidade,
  //     telefone: medicoSelecionado.telefone,
  //     especialidade: medicoSelecionado.especialidade
  //   });
  // }

  getMedStatus(): string {
    const validMed = !!this.medicoForm.get('validMed')?.value;
    const filter = this.medicoForm.get('ConteudoMedFiltro')?.value || [];
    const count = filter.length;

    if (validMed) return 'Válido';
    if (count > 0) return 'Ambíguo';
    return 'Não encontrado';
  }

  getMedStatusClass(): string {
    const status = this.getMedStatus();

    switch (status) {
      case 'Ambíguo': return 'ambiguous';
      case 'Válido': return 'valid';
      case 'Não encontrado': return 'not-found';
      default: return '';
    }
  }

  isAmbiguousMed(): boolean {
    return this.getMedStatus() === 'Ambíguo';
  }

  isValidMed(): boolean {
    return this.getMedStatus() === 'Válido';
  }

  isNotFoundMed(): boolean {
    return this.getMedStatus() === 'Não encontrado';
  }

  verificarAtalho(event: KeyboardEvent, campo: string) {
    let campoToNumber = parseInt(campo, 10);
    if (event.altKey && (event.key === 'e' || event.key === 'E')) {
      this.addEspecialidadeIndex(campoToNumber);
    }
    if (event.altKey && (event.key === 's' || event.key === 'S')) {
      const especialidadeArray = this.medicoForm.get('especialidade') as FormArray;
      if (especialidadeArray.length > 1) {
        this.removeEspecialidade(campoToNumber);
      }
    }
  }

  abrirModalMedico(usarRetornoComoPesquisa: boolean = false): void {
    this.isModalMedicoOpen = true;
    const retornoMedico = this.medicoForm.get('retorno_med')?.value || '';
    this.pesquisaMedico = usarRetornoComoPesquisa ? retornoMedico : ''; 
    this.medicoSelecionadoCombobox = '';
    
    this.medicoSelecionadoNome = this.medicoForm.get('nome')?.value || '';
    this.matriculaSelecionada = this.medicoForm.get('retorno_matricula')?.value || this.medicoForm.get('retorno_matricula1')?.value || this.medicoForm.get('retorno_matricula2')?.value || ''; 
    this.focusComboOnLoad = !usarRetornoComoPesquisa;
    this.buscarMedicosApi(); 

    setTimeout(() => {
      if (usarRetornoComoPesquisa) {
        const inputElement = document.querySelector('.modal-body input[type="text"]') as HTMLInputElement;
        if (inputElement) {
          inputElement.focus();
        }
      }
    }, 100);
  }

  abrirModalMedicoSpace(event: Event): void {
    event.preventDefault();
    this.abrirModalMedico(true);
  }

  abrirModalMedicoEnter(event: Event): void {
    event.preventDefault();
    this.abrirModalMedico(true);
  }

  fecharModalMedico(): void {
    this.isModalMedicoOpen = false;
    this.pesquisaMedico = '';
    this.medicoSelecionadoCombobox = '';
    this.listaMedicosFiltrada = [];
    this.listaMedicosCompleta = [];
  }

  buscarMedicosApi(termoBuscaParam?: string): void {
    const termoBusca = (termoBuscaParam || this.medicoSelecionadoNome || '').trim();
    
    if (!termoBusca) {
      this.listaMedicosCompleta = [];
      this.focusComboOnLoad = false;
      this.filtrarMedicos();
      return;
    }

    if (this.ultimoTermoBuscaMedicoApi === termoBusca) {
      return;
    }

    if (this.isBuscandoMedicos) {
      this.termoBuscaMedicoPendente = termoBusca;
      return;
    }

    this.isBuscandoMedicos = true;
    this.ultimoTermoBuscaMedicoApi = termoBusca;

    const body: any = {
      pais: this.codigoPaisMaestro || '',
      cidade: this.codigoRegiaoMaestro || '',
      quantidade: "30",
      nome: termoBusca
    };

    this.jsonService.findMedicoEs(body).subscribe({
      next: (resp: any[]) => {
        const itemNaoEncontrado = {
          name: this.translate.instant('Médico não encontrado na pesquisa.'),
          matricula: '',
          especialidade: '',
          nro_medico: '',
          isNotFoundItem: true
        };

        const apiMedicos = resp.map((item: any) => ({ 
          name: typeof item.medico === 'string' ? item.medico.replace(/'/g, '') : item.medico, 
          matricula: typeof item.matricula === 'string' ? item.matricula.replace(/'/g, '') : item.matricula,
          especialidade: typeof item.especialidad === 'string' ? item.especialidad.replace(/'/g, '') : item.especialidad,
          nro_medico: item.nro_medico || '',
        }));
        
        this.listaMedicosCompleta = [
          itemNaoEncontrado,
          ...apiMedicos
        ].map((item, index) => ({ ...item, id: index }));

        this.filtrarMedicos();

        if (this.focusComboOnLoad) {
          this.focusComboOnLoad = false;
          setTimeout(() => {
            const selectElement = document.querySelector('.modal-body select') as HTMLSelectElement;
            if (selectElement) selectElement.focus();
          }, 100);
        }

        if (this.pesquisaMedico && this.pesquisaMedico.trim() !== '') {
          const termoPesquisaLower = this.pesquisaMedico.trim().toLowerCase();
          const matchExato = this.listaMedicosFiltrada.find(med => {
            const nomeMedico = (med.name || '').trim().toLowerCase();
            return !med.isNotFoundItem && nomeMedico === termoPesquisaLower;
          });
          if (matchExato) {
            this.medicoSelecionadoCombobox = matchExato.id.toString();
          }
        }

      },
      error: (e: any) => {
        this.logger.error('Erro na busca de médicos por similaridade', e);
        this.listaMedicosCompleta = [];
        this.listaMedicosFiltrada = [];
        this.focusComboOnLoad = false;
        this.isBuscandoMedicos = false;
      },
      complete: () => {
        this.isBuscandoMedicos = false;
        if (this.termoBuscaMedicoPendente) {
          const proximoTermo = this.termoBuscaMedicoPendente;
          this.termoBuscaMedicoPendente = '';
          this.buscarMedicosApi(proximoTermo);
        }
      }
    });
  }

  private deveRefazerBuscaMedicoApi(termoBusca: string): boolean {
    if (!this.ultimoTermoBuscaMedicoApi || termoBusca === this.ultimoTermoBuscaMedicoApi) {
      return false;
    }

    const termoAtualLower = termoBusca.toLowerCase();
    const ultimoTermoLower = this.ultimoTermoBuscaMedicoApi.toLowerCase();
    const palavrasAtuais = termoAtualLower.split(/\s+/).filter(Boolean);
    const palavrasUltimaBusca = ultimoTermoLower.split(/\s+/).filter(Boolean);

    return palavrasAtuais.length > palavrasUltimaBusca.length && termoAtualLower.startsWith(ultimoTermoLower);
  }

  filtrarMedicos(): void {
    const termoBusca = (this.pesquisaMedico || '').trim();
    
    if (!termoBusca) {
      this.listaMedicosFiltrada = [...this.listaMedicosCompleta];
      return;
    }

    const isNumeric = /^\d+$/.test(termoBusca);

    if (isNumeric) {
      this.listaMedicosFiltrada = this.listaMedicosCompleta.filter(m => 
        m.isNotFoundItem || (m.matricula && m.matricula.includes(termoBusca))
      );
    } else {
      const termoLower = termoBusca.toLowerCase();
      this.listaMedicosFiltrada = this.listaMedicosCompleta.filter(m => 
        m.isNotFoundItem ||
        (m.name && m.name.toLowerCase().includes(termoLower)) || 
        (m.especialidade && m.especialidade.toLowerCase().includes(termoLower))
      );
    }

    if (this.listaMedicosFiltrada.length === 2 && this.listaMedicosFiltrada[0].isNotFoundItem) {
      this.medicoSelecionadoCombobox = this.listaMedicosFiltrada[1].id.toString();
      setTimeout(() => {
        const selectElement = document.querySelector('.modal-body select') as HTMLSelectElement;
        if (selectElement) {
          selectElement.focus();
        }
      }, 100);
    }

    const possuiMedicoNaLista = this.listaMedicosFiltrada.some(m => !m.isNotFoundItem);
    if (!possuiMedicoNaLista || this.deveRefazerBuscaMedicoApi(termoBusca)) {
      this.buscarMedicosApi(termoBusca);
    }
  }

  private atualizarMedicoSelecionado(medicoSelecionado: any): void {
    if (!medicoSelecionado) return;

    let nomeFinal: string;
    let matriculaFinal: string;
    let especialidadeFinal: string;
    let especialidadeFinal2: string = '';
    let enderecoFinal: string;
    let localidadeFinal: string;

    if (medicoSelecionado.isNotFoundItem) {
      nomeFinal = (this.medicoForm.get('nome')?.value || '').trim();
      matriculaFinal = (this.medicoForm.get('matricula')?.value || '').trim();
      
      const espArray = this.medicoForm.get('especialidade') as FormArray;
      especialidadeFinal = espArray && espArray.controls.length > 0 ? (espArray.at(0).value || '').trim() : '';
      especialidadeFinal2 = espArray && espArray.controls.length > 1 ? (espArray.at(1).value || '').trim() : '';
      
      enderecoFinal = (this.medicoForm.get('rua')?.value || '').trim();
      localidadeFinal = (this.medicoForm.get('localidade')?.value || '').trim();
    } else {
      nomeFinal = medicoSelecionado.name;
      matriculaFinal = medicoSelecionado.matricula || '';
      especialidadeFinal = medicoSelecionado.especialidade || '';
      enderecoFinal = '';
      localidadeFinal = '';
    }

    if (nomeFinal) {
        const filter = this.medicoForm.get('ConteudoMedFiltro')?.value || [];
        const matched = filter.find((m: any) => m.NOMBRE_MEDICO === nomeFinal);
        
        if (!matched) {
          const novoMedico = {
            NOMBRE_MEDICO: nomeFinal,
            MATRICULA1: matriculaFinal,
            ESPECIALIDAD: especialidadeFinal,
            ESPECIALIDAD2: especialidadeFinal2,
            DIRECCION: enderecoFinal,
            LOCALIDAD: localidadeFinal,
            NRO_MEDICO: medicoSelecionado.isNotFoundItem ? '' : (medicoSelecionado.nro_medico || '')
          };
          // Só adiciona ao array se já existiam opções, evitando que o input mude para 'Ambíguo'
          if (filter.length > 0) {
            this.medicoForm.get('ConteudoMedFiltro')?.setValue([...filter, novoMedico]);
          }
          this.updateReturnFields(novoMedico);
        } else {
          this.updateReturnFields(matched);
          // Candidato antigo sem NRO_MEDICO: usa o número que a pesquisa por similaridade devolveu.
          if (!matched.NRO_MEDICO && !medicoSelecionado.isNotFoundItem && medicoSelecionado.nro_medico) {
            this.medicoForm.patchValue({ retorno_nro_medico: medicoSelecionado.nro_medico }, { emitEvent: false });
          }
        }

        this.medicoForm.get('retorno_med')?.setValue(nomeFinal);
        this.medicoForm.get('interaccion_del_usuario')?.setValue(
          this.translate.instant(medicoSelecionado.isNotFoundItem ? 'Item informado pelo usuário' : 'Item adicionado por pesquisa')
        );
        this.isMedicoVerificadoChecked = medicoSelecionado.isNotFoundItem === true;
        this.atualizarValidacao();
    }
  }

  onMedicoClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.tagName.toLowerCase() === 'option') {
      const option = target as HTMLOptionElement;
      this.medicoSelecionadoCombobox = option.value;
      this.confirmarSelecaoCombo(event);
    }
  }

  confirmarSelecaoCombo(event?: Event): void {
    if (event) {
      event.preventDefault();
    }
    if (this.medicoSelecionadoCombobox !== '' && this.medicoSelecionadoCombobox !== null) {
      const selectedIndex = parseInt(this.medicoSelecionadoCombobox as string, 10);
      const med = this.listaMedicosFiltrada[selectedIndex];
      if (med) {
        this.atualizarMedicoSelecionado(med);
        this.fecharModalMedico();
      }
    }
  }

  openCombo(event: Event): void {
    const kbEvent = event as KeyboardEvent;
    let isArrowDown = false;
    let isShiftO = false;

    if (kbEvent && kbEvent.type === 'keydown') {
      isShiftO = kbEvent.shiftKey && (kbEvent.key === 'o' || kbEvent.key === 'O');
      isArrowDown = kbEvent.key === 'ArrowDown';

      if (!isShiftO && !isArrowDown) {
        return;
      }
    }

    const selectElement = document.querySelector('.modal-body select') as HTMLSelectElement;
    if (selectElement) {
      if (isShiftO || (isArrowDown && document.activeElement !== selectElement)) {
        event.preventDefault();
      }
      selectElement.focus();
    }
  }

  @HostListener('window:keydown', ['$event'])
  handleShiftM(event: KeyboardEvent): void {
    if (event.shiftKey && (event.key === 'm' || event.key === 'M')) {
      event.preventDefault();
      if (!this.isValidMed()) {
        if (this.retornoMedSelect?.nativeElement) {
          this.retornoMedSelect.nativeElement.focus();
        } else if (this.retornoMedInput?.nativeElement) {
          this.retornoMedInput.nativeElement.focus();
        }
      }
    }
  }

  @HostListener('document:keydown', ['$event'])
  handleDocumentKeydown(event: KeyboardEvent): void {
    if (this.isModalMedicoOpen && event.altKey && /^[0-9]$/.test(event.key)) {
      event.preventDefault();
      event.stopPropagation();
      const num = parseInt(event.key, 10);
      const index = num; // Mapeia exatamente 0-9 para os índices 0-9 da lista
      if (this.listaMedicosFiltrada && this.listaMedicosFiltrada[index]) {
        this.medicoSelecionadoCombobox = index.toString();
        this.confirmarSelecaoCombo(event);
      }
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    if (this.isModalMedicoOpen) {
      this.fecharModalMedico();
    }
  }
  
    
  public loadChangeDetector() {
    const medicoGroup = this.medicoForm as FormGroup;
    const subscribeFilter = <T>(
      control: AbstractControl | null,
      sourceList: T[],
      filterFn: (item: T, value: string) => boolean,
      callback: (filtered: T[]) => void
    ) => {
      if (!control) return;
      control.valueChanges.subscribe(value => {
        const val = (value || '').toUpperCase();
        callback(sourceList.filter(item => filterFn(item, val)));
      });
    };
    if (medicoGroup) {
      const abreviacoes: Record<string, string> = {
        'AZ': 'ALVAREZ', 'CZ': 'CHAVEZ', 'DZ': 'DOMINGUEZ', 'FZ': 'FERNANDEZ',
        'FS': 'FLORES', 'GA': 'GARCIA', 'GZZ': 'GONZALEZ', 'GTZ': 'GUTIERREZ',
        'HZ': 'HERNANDEZ', 'JZ': 'JIMENEZ', 'MZ': 'MARTINEZ', 'MS': 'MORALES',
        'MO': 'MORENO', 'RZ': 'RAMIREZ', 'RS': 'RAMOS', 'RDZ': 'RODRIGUEZ',
        'RO': 'ROMERO', 'SZ': 'SANCHEZ', 'TS': 'TORRES', 'VS': 'VASQUEZ',
        'VZ': 'VAZQUEZ'
      };
      // Filtrar por matrícula
      subscribeFilter(
        medicoGroup.get('matricula'),
        this.global.listaNomeMedico,
        (item, value) => (item['matricula'] || '').toUpperCase().startsWith(value),
        filtered => this.crmFiltrado = filtered
      );
      // Filtrar por nome
      subscribeFilter(
        medicoGroup.get('nome'),
        this.global.listaNomeMedico,
        (item, valueRaw) => {
          const endsWithSpace = valueRaw?.endsWith(' ') ?? false;
          let value = valueRaw.trim();
          const isNumeric = /^\d+$/.test(value);
          let partes = value.split(' ').filter(Boolean).map(p => abreviacoes[p] || p);
          value = partes.join(' ');
          if (endsWithSpace) partes.push('');

          const nome = (item['nome'] || '').toUpperCase();
          const matricula = (item['matricula'] || '').toUpperCase();
          const partesNome = nome.split(' ').filter(Boolean);

          if (isNumeric && value.length > 0) return matricula === value;
          if (partes.length === 1 && value.length !== 3) return nome.startsWith(value);
          if (partes.length === 1 && value.length === 3) return value.split('').every(l => partesNome.map(p => p[0]).includes(l));
          if (partes.length > 1) return partes.every(p => nome.includes(p));

          return nome.includes(value);
        },
        filtered => this.nomeMedicoFiltrado = filtered
      );
    }
  }
}
